import { render, staticRenderFns } from "./products.vue?vue&type=template&id=e9f1ebd6&scoped=true"
import script from "./products.vue?vue&type=script&lang=js"
export * from "./products.vue?vue&type=script&lang=js"
import style0 from "./products.vue?vue&type=style&index=0&id=e9f1ebd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f1ebd6",
  null
  
)

export default component.exports